import { Dispatch } from 'redux';
import types from 'redux/actions/actionTypes';
import { axiosV2 } from 'interceptors/axios';
import { PaginationOptions } from 'react-data-table-component';

import { Operation } from 'types';

import { decryptResponse } from 'utils/token';
import { dispatchError } from 'utils/dispatchError';
import { ApiQueryParams } from 'types/ApiQueryParams';
import { updatePartnerShares } from '../utils/updatePartnerShares';
import { updateSocietyData } from '../../society/redux/updateSocietyData';

type UpdateOperationProps = {
  id: string;
  data: Partial<Operation> & { userId: string; societyId: string };
  showAlert?: boolean;
};

export const addOperation =
  (operationData: Partial<Operation>) => async (dispatch: Dispatch) => {
    try {
      const body = { ...operationData };
      const { data } = await axiosV2.post('/operations', body);
      const decodedData: any = await decryptResponse(data);

      dispatch({
        type: types.CREATE_OPERATION,
        operation: decodedData.operation,
      });

      updatePartnerShares(decodedData, dispatch);
      updateSocietyData(decodedData, dispatch);
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };

export const getOperations =
  (societyId: string, params: any) => async (dispatch: any) => {
    const query = { params: { societyId, ...params } };

    try {
      const { data } = await axiosV2.get('/operations', query);

      const decodedData = (await decryptResponse(data)) as {
        data: Operation[];
        pagination: PaginationOptions;
      };
      const operations = decodedData.data;

      dispatch({
        type: types.GET_OPERATIONS,
        operations,
      });

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };

export const getOperation =
  (operationId: string, params?: ApiQueryParams) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV2.get(`/operations/${operationId}`, {
        params,
      });
      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };

export const updateOperation =
  ({ id, data }: UpdateOperationProps) =>
  async (dispatch: Dispatch) => {
    const query = { _id: id, ...data };

    try {
      const { data } = await axiosV2.put(`/operations`, query);
      const decodedData = await decryptResponse(data);

      dispatch({
        type: types.UPDATE_OPERATION,
        operation: decodedData,
      });
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };

export const deleteOperation =
  (operationId: string) => async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV2.delete(`/operations/${operationId}`);
      const decodedData = await decryptResponse(data);

      updatePartnerShares(decodedData, dispatch);
      updateSocietyData(decodedData, dispatch);

      dispatch({
        type: types.DELETE_OPERATION,
        operationId,
      });
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
